import { render, staticRenderFns } from "./CollegeSubject.vue?vue&type=template&id=0e9a5b1a&scoped=true&lang=html&"
import script from "./CollegeSubject.vue?vue&type=script&lang=js&"
export * from "./CollegeSubject.vue?vue&type=script&lang=js&"
import style0 from "./CollegeSubject.vue?vue&type=style&index=0&id=0e9a5b1a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a5b1a",
  null
  
)

export default component.exports